import copyToClipboard from '../../../helpers/copyToClipboard';
import addGoogleAnalyticsEventLog from '../../../helpers/addGoogleAnalyticsEventLog';

const servicesSliders: NodeListOf<HTMLElement> = document.querySelectorAll('.services-slider');

if (servicesSliders.length > 0) {
    const currentCulture: string = document.documentElement.getAttribute('culture');

    servicesSliders.forEach((slider) => {
        const pageTitle = slider.getAttribute('data-page-title');

        slider.querySelectorAll('.services-slider__link').forEach((link) => {
            link.addEventListener('click', () => {
                addGoogleAnalyticsEventLog('content_page_view', {
                    page_title: pageTitle,
                    content_type: 'Service',
                    language: currentCulture,
                });
            });
        });

        slider.querySelectorAll<HTMLButtonElement>('.shareButton').forEach((button) => {
            button.addEventListener('click', () => {
                const link = button.getAttribute('data-link');
                copyToClipboard(button, link ? new URL(link, window.location.origin).href : window.location.href);
            });
        });
    });
}
